import React, { useState } from 'react';
import RiskDescriptions from './RiskDescriptions/RiskDescriptions';
import CapacityForLossToggles from './CapacityForLossToggles/CapacityForLossToggles';
import CustomTypicalAssetAllocations from './CustomTypicalAssetAllocations/CustomTypicalAssetAllocations';

type RiskAnalysisProps = { isFirmAdmin: boolean; setDirty: Function };

const RiskAnalysis: React.FC<RiskAnalysisProps> = ({
  isFirmAdmin,
  setDirty
}) => {
  const [selectedProfiler, setSelectedProfiler] = useState<string | null>(null);

  return (
    <div>
      <CapacityForLossToggles
        isFirmAdmin={isFirmAdmin}
        selectedProfiler={selectedProfiler}
        setSelectedProfiler={setSelectedProfiler}
      />
      {selectedProfiler === 'EValue' && (
        <>
          <RiskDescriptions isFirmAdmin={isFirmAdmin} setDirty={setDirty} />
          <CustomTypicalAssetAllocations
            isFirmAdmin={isFirmAdmin}
            setDirty={setDirty}
          />
        </>
      )}
    </div>
  );
};

export default RiskAnalysis;
